<h2 mat-dialog-title data-translation-key="buyer_header_select_your_timezone">
  {{ 'buyer_header.select_your_timezone' | translate }}
</h2>
<div mat-dialog-content>
  <div class="form-inner">
    <input
      type="text"
      [(ngModel)]="searchQuery"
      (input)="filterTimezones()"
      name="search"
      [placeholder]="'timezone_dialog.buyer_header_search_timezone' | translate"
      data-translation-key="buyer_header_search_timezone"
      />
    </div>

    @if (filteredTimezones.length > 0) {
      <div class="timezone-list">
        @for (tz of filteredTimezones; track tz) {
          <div
            class="timezone-option"
            [class.selected]="tz === selectedTimezone"
            (click)="selectTimezone(tz)"
            >
            <div class="timezone-info">
              <div class="timezone-name">{{ tz.replace("_", " ") }}</div>
              <div class="timezone-offset">({{ getTimezoneOffset(tz) }})</div>
            </div>
            <div class="timezone-time">{{ getTimeInZone(tz) }}</div>
          </div>
        }
      </div>
    }

    @if (filteredTimezones.length === 0) {
      <div
        class="no-results"
        data-translation-key="buyer_header_no_timezones_available"
        >
        {{ 'buyer_header.no_timezones_available' | translate }}
      </div>
    }
  </div>
  <div mat-dialog-actions align="end" class="d-flex gap-1">
    <button
      class="btn btn-sm bg-secondary text-white"
      (click)="onCancel()"
      data-translation-key="buyer_header_time_zone_cancel"
      >
      {{ 'buyer_header.time_zone_cancel' | translate }}
    </button>

    <button
      [disabled]="!selectedTimezone"
      (click)="onConfirm()"
      class="btn btn-sm bg-success text-white"
      >
      {{ 'buyer_header.time_zone_confirm' | translate }}
    </button>
  </div>
